import React from 'react';
import { useTranslation } from 'react-i18next';

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';

import { useStyles } from './styles';

export const BookingConfirmDialog = ({ open, handleClose, title }) => {
  const classes = useStyles();
  const [t] = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {t('Your booking was successfully created!')}
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          id="alert-dialog-description"
          className={classes.content}
        >
          {t('Thank you for booking')} {title}!{' '}
          {t('The details of your booking will be sent to your email.')}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <div className={classes.buttonWrapper}>
          <Button
            className={classes.button}
            variant="outlined"
            onClick={handleClose}
          >
            Ok
          </Button>
        </div>
      </DialogActions>
    </Dialog>
  );
};
